import { _ as _createClass, a as _classCallCheck, b as attachEvent, c as _inherits, d as _getPrototypeOf, e as _possibleConstructorReturn, f as createRect, s as setNodeAttrs, g as createGroup, h as createShape, i as createVectorWrapperGroup, j as addToNode, r as removeNode, k as findInNodeTree, l as createStage, m as createLayer, n as getNodeChildrenArray, o as findTransformer, p as getNodeAttrs, q as nodeMoveToTop, t as drawNode, u as isInstanceofGroup, V as VectorWrapperGroup, v as removeNodeChildren, w as getNodeParent, x as getNodes, y as getNodeActiveAnchor, z as findNodeFirstIdentifier, A as getNodeStage, B as createLabel, C as attachEventOnce, D as addNodeIntoLabel, E as createTag, F as createText, G as addNodeIntoTransformer, H as findNode, I as findRect, J as createPath, K as findShape, L as createTransformer$1, M as Konva, N as detachEventAllHandlers, O as getNodeContainer, P as _toArray, Q as getClientRect, R as isInstanceofText, S as findTransformerBackShape, T as getStagePointerPosition, U as fireNodeEvent, W as setNodes, X as showNode, Y as hideNode, Z as createLine, $ as batchDrawNode, a0 as destroyNode } from '../selectors-f64b5778.js';
import { _ as _defineProperty } from '../defineProperty-18999f8e.js';
import AnimationsApi from '../api/animationApi/index.js';
import { _ as _toConsumableArray } from '../toConsumableArray-2a2700d9.js';
import { _ as _asyncToGenerator, r as regenerator } from '../index-6bb2031f.js';
import { D as DependencyType, L as LayerType } from '../common-94559169.js';
import { MAX_PATH_VALUE, BIG_RECT, HUNDRED_PERCENT, isDev, TRANSFORMER_MIDDLE_ANCHOR_MIN, TRANSFORMER_MIDDLE_ANCHOR_MAX, TRANSFORMER_ROTATER_BOX_SIZE, TRANSFORMER_ROTATER_BOX_SIZE_OFFSET, Anchors, DEFAULT_TR, TRANSFORMER_ANCHOR_SIZE, TRANSFORMER_BORDER_OFFSET, isTest } from '../configs/index.js';
import { t as tinycolor } from '../tinycolor-c9a47691.js';
import getColorLayerDefaultAttrs from '../defaults/color/index.js';
import { B as BaseLayer, g as getSaturatedColor } from '../base-a1755813.js';
import { I as ImageLayer, i as intersection_1, g as getImageLayerResources } from '../getImageLayerResources-2566d896.js';
import getGroupLayerDefaultAttrs from '../defaults/group/index.js';
import getVectorLayerDefaultAttrs from '../defaults/vector/index.js';
import { handlePointerPath } from '../layers/vector/utils/index/index.js';
import { v as v4 } from '../v4-c5e36445.js';
import { C as CustomTextLayer, g as getTextTopLeftPosition } from '../getTextTopLeftPosition-9ee3ed25.js';
import callbacksResolver from '../utils/callbacksResolver/index.js';
import generateDependency from '../utils/generateDependency/index.js';
import isBaseGroupLayer from '../utils/isBaseGroupLayer/index.js';
import { _ as _slicedToArray } from '../slicedToArray-26803f33.js';
import createLayers from '../api/createLayers/index.js';
import onLayerReady from '../api/onLayerReady/index.js';
import onLayerUpdate from '../api/onLayerUpdate/index.js';
import { isLayerReady } from '../api/isLayerReady/index.js';
import { layerToImage, layerToCanvas, layerToDataUrl } from '../utils/layerUtils/index.js';
import onLayerChange from '../api/onLayerChange/index.js';
import { stageZoomReposition, stageScaleChange, stageReposition, getStagePosition, resetStagePosition } from '../api/stageZoomReposition/index.js';
import degreeToRadian from '../geometry/degreeToRadian/index.js';
import radianToDegree from '../geometry/radianToDegree/index.js';
import { i as isEqual_1 } from '../isEqual-347ac7db.js';
import hasIntersectionWithPoint from '../geometry/hasIntersectionWithPoint/index.js';
import { updateTransformer } from '../api/updateTransformer/index.js';
import { changeScaleToFontSize } from '../utils/changeScaleToFontSize/index.js';
import calcStagePosition from '../utils/calcStagePosition/index.js';
import onLayerReadyWithChildren from '../api/onLayerReadyWithChildren/index.js';
import '../layers/image/utils/index/index.js';
import getTransformedText from '../utils/getTransformedText/index.js';
import getNodeGeometryMetrics from '../utils/getNodeGeometryMetrics/index.js';
import '../typeof-92b42de1.js';
import '../unsupportedIterableToArray-577176bf.js';
import '@picsart/rc/noop';
import '../utils/getResetLayerAttrs/index.js';
import '../defaults/base/index.js';
import '../isObjectLike-66611f04.js';
import '../_commonjsHelpers-1789f0cf.js';
import '../layers/vector/utils/applyBrightness/index.js';
import '../layers/vector/utils/applyContrast/index.js';
import '../utils/attachDragBoundEvents/index.js';
import '../utils/loadingImage/index.js';
import '../utils/imageReadyResolver/index.js';
import '../defaults/image/index.js';
import '../external/index.js';
import '@pa/editor-lib';
import '../layers/image/utils/applyMask/index.js';
import '../layers/image/utils/applyAdjust/index.js';
import '@pa/pilibs';
import '../layers/image/utils/applyEffect/index.js';
import '../layers/image/utils/applyOriginalImageChanges/index.js';
import '../utils/vector/index.js';
import '../layers/vector/utils/svg-utils/index.js';
import '../utils/loadFont/index.js';
import '../utils/getTextFill/index.js';
import '../defaults/text/index.js';
import '../utils/hasScroll/index.js';
import '../utils/calculateCanvasHeight/index.js';
import '../api/getPositionAfterZoom/index.js';
import '../geometry/getNotRotatedCoords/index.js';
import '../utils/scaleToFontSize/index.js';

var Renderer = /*#__PURE__*/function () {
  function Renderer(renderer, layerProvider) {
    var _this = this;

    _classCallCheck(this, Renderer);

    _defineProperty(this, "redrawTree", function (layers) {
      // TODO:: need to fix update one layer itself
      var layersObj = layers.reduce(function (acc, layer) {
        acc[layer.id] = _this.layerProvider.layerRegistry[layer.id].layer;
        return acc;
      }, {});
      !!Object.keys(layersObj).length && _this.renderer.drawTree(layersObj);
    });

    _defineProperty(this, "draw", function () {
      _this.renderer.render();
    });

    this.renderer = renderer;
    this.renderer = renderer;
    this.layerProvider = layerProvider;
  }

  _createClass(Renderer, [{
    key: "addNodePlugin",
    value: function addNodePlugin(plugin) {
      return this.renderer.addNodePlugin(plugin);
    }
  }, {
    key: "syncLayers",
    value: function syncLayers(serializableLayers) {
      // as synclayers is async,let renderer know that draw will be triggered
      this.renderer.waitForDraw();
      return this.layerProvider.syncLayers(serializableLayers, this.draw);
    }
  }]);

  return Renderer;
}();

function onClick(layerProvider, id, handler) {
  var layerObject = layerProvider.layerRegistry[id];
  return attachEvent(layerObject.layer.innerRenderable, 'click', function (event) {
    return handler(event.evt);
  });
}

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ColorLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(ColorLayer, _BaseLayer);

  var _super = _createSuper$2(ColorLayer);

  function ColorLayer(partialArgs) {
    var _this;

    _classCallCheck(this, ColorLayer);

    var args = _objectSpread$7(_objectSpread$7({}, getColorLayerDefaultAttrs()), partialArgs);

    _this = _super.call(this, args, ['colorRGB1', 'colorRGB2', 'colorTransparent']);
    var colorRGB1 = args.colorRGB1,
        colorRGB2 = args.colorRGB2,
        colorTransparent = args.colorTransparent;
    _this.colorRGB1 = colorRGB1;
    _this.colorRGB2 = colorRGB2;
    _this.colorTransparent = colorTransparent;

    _this.generate();

    return _this;
  }

  _createClass(ColorLayer, [{
    key: "generateRenderable",
    value: function generateRenderable() {
      this.innerRenderable = createRect({
        x: this.x,
        Y: this.y,
        fill: this.getFill(),
        width: this.width,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        height: this.height,
        rotation: this.rotation,
        listening: this.interactable,
        fillLinearGradientStartPoint: {
          x: 0,
          y: 0
        },
        fillLinearGradientEndPoint: {
          x: this.width,
          y: this.height
        },
        fillLinearGradientColorStops: this.hasGradient() ? [0, tinycolor(this.colorRGB1).toRgbString(), 1, tinycolor(this.colorRGB2).toRgbString()] : undefined,
        fillEnabled: true,
        fillPriority: 'linear-gradient'
      });
      this.readyToRender = true;
      this.eventTarget.dispatchEvent(this.readyEvent);
    }
  }, {
    key: "hasGradient",
    value: function hasGradient() {
      return !this.colorTransparent && !!this.colorRGB2;
    }
  }, {
    key: "getFill",
    value: function getFill() {
      var color = tinycolor(this.colorRGB1);

      if (this.colorTransparent) {
        color.setAlpha(0);
      }

      return color.toRgbString();
    }
  }, {
    key: "updateRenderable",
    value: function updateRenderable() {
      setNodeAttrs(this.innerRenderable, {
        fill: this.getFill(),
        width: this.width,
        height: this.height,
        fillLinearGradientStartPoint: {
          x: 0,
          y: 0
        },
        fillLinearGradientEndPoint: {
          x: this.width,
          y: this.height
        },
        fillLinearGradientColorStops: this.hasGradient() ? [0, tinycolor(this.colorRGB1).toRgbString(), 1, tinycolor(this.colorRGB2).toRgbString()] : undefined,
        fillEnabled: true,
        fillPriority: 'linear-gradient'
      });
    }
  }]);

  return ColorLayer;
}(BaseLayer);

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GroupLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(GroupLayer, _BaseLayer);

  var _super = _createSuper$1(GroupLayer);

  function GroupLayer(partialArgs) {
    var _this;

    _classCallCheck(this, GroupLayer);

    var args = _objectSpread$6(_objectSpread$6({}, getGroupLayerDefaultAttrs()), partialArgs);

    _this = _super.call(this, args, ['draggable', 'clip']);
    _this.clip = args.clip;

    _this.generate();

    return _this;
  }

  _createClass(GroupLayer, [{
    key: "generateRenderable",
    value: function () {
      var _generateRenderable = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.innerRenderable = createGroup({
                  x: this.x,
                  y: this.y,
                  id: this.id,
                  clip: this.clip,
                  width: this.width,
                  height: this.height,
                  scaleX: this.scaleX,
                  scaleY: this.scaleY,
                  rotation: this.rotation,
                  draggable: this.draggable,
                  listening: this.interactable
                });

                if (this.clip) {
                  this.innerRenderable.clip(this.clip);
                }

                this.readyToRender = true;
                this.visible = true;
                this.eventTarget.dispatchEvent(this.readyEvent);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function generateRenderable() {
        return _generateRenderable.apply(this, arguments);
      }

      return generateRenderable;
    }()
  }, {
    key: "updateRenderable",
    value: function updateRenderable() {
      if (!this.readyToRender) {
        return;
      }

      setNodeAttrs(this.innerRenderable, {
        clip: this.clip,
        width: this.width,
        height: this.height
      });
    }
  }]);

  return GroupLayer;
}(BaseLayer);

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var VectorLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(VectorLayer, _BaseLayer);

  var _super = _createSuper(VectorLayer);

  function VectorLayer(partialArgs) {
    var _this;

    _classCallCheck(this, VectorLayer);

    var args = _objectSpread$5(_objectSpread$5({}, getVectorLayerDefaultAttrs()), partialArgs);

    _this = _super.call(this, args, ['paths', 'adjust', 'colorRGB1', 'shadowBlur', 'shadowColor', 'shadowOpacity', 'shadowOffsetX', 'shadowOffsetY', 'shadowTransparent', 'outlineSize', 'cornerRadius', 'outlineColor', 'opacityOutline', 'colorTransparent', 'outlineTransparent']);
    _this.method = 'fill';
    var paths = args.paths,
        colorRGB1 = args.colorRGB1,
        outlineColor = args.outlineColor,
        cornerRadius = args.cornerRadius,
        colorTransparent = args.colorTransparent,
        outlineTransparent = args.outlineTransparent,
        outlineSize = args.outlineSize,
        opacityOutline = args.opacityOutline,
        shadowColor = args.shadowColor,
        shadowBlur = args.shadowBlur,
        shadowOffsetX = args.shadowOffsetX,
        shadowOffsetY = args.shadowOffsetY,
        shadowOpacity = args.shadowOpacity,
        shadowTransparent = args.shadowTransparent,
        adjust = args.adjust;
    _this.adjust = adjust;
    _this.paths = paths;
    _this.colorRGB1 = colorRGB1;
    _this.outlineSize = outlineSize;
    _this.outlineColor = outlineColor;
    _this.opacityOutline = opacityOutline;
    _this.colorTransparent = colorTransparent;
    _this.outlineTransparent = outlineTransparent;
    _this.shadowBlur = shadowBlur;
    _this.shadowColor = shadowColor;
    _this.shadowOpacity = shadowOpacity;
    _this.shadowOffsetY = shadowOffsetY;
    _this.shadowOffsetX = shadowOffsetX;
    _this.shadowTransparent = shadowTransparent;
    _this.initialRectX = null;
    _this.initialRectY = null; // Require path update

    _this.cornerRadius = cornerRadius;
    _this.pointerPath = [];
    _this.isPlaceholder = false;

    _this.generate();

    return _this;
  }

  _createClass(VectorLayer, [{
    key: "isCollage",
    value: function isCollage() {
      // TODO set specific dependency type for collages (https://picsart.atlassian.net/browse/PIA-170475)
      return this.dependencies.filter(function (_ref) {
        var type = _ref.type;
        return type !== DependencyType.STICKY;
      }).length > 0;
    }
  }, {
    key: "setupCollage",
    value: function setupCollage() {
      var _this2 = this;

      // Konva wraps canvas2d in it's own Context
      // @ts-ignore
      this.innerRenderable.clipFunc(function (ctx) {
        return _this2.renderFunc(ctx, 'clip');
      });
    }
  }, {
    key: "generateRenderable",
    value: function generateRenderable() {
      var _this3 = this;

      if (this.paths.length > MAX_PATH_VALUE) {
        throw new Error('Please use Image layer');
      }

      this.shape = createShape({
        id: "".concat(this.id, "shape"),
        draggable: this.draggable,
        listening: this.interactable,
        sceneFunc: function sceneFunc(ctx) {
          return _this3.renderFunc(ctx, 'fill');
        },
        globalCompositeOperation: this.globalCompositeOperation
      });
      this.innerRenderable = createVectorWrapperGroup({
        id: this.id,
        x: this.x,
        y: this.y,
        width: this.width,
        height: this.height,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        rotation: this.rotation,
        draggable: this.draggable,
        listening: this.interactable
      });
      this.defaultClipFunc = this.innerRenderable.clipFunc;
      this.hiddenRect = createRect({
        draggable: false,
        width: this.width,
        height: this.height,
        opacity: 1,
        id: v4()
      });
      addToNode(this.innerRenderable, this.shape);
      this.isCollage() ? this.setupCollage() : addToNode(this.innerRenderable, this.hiddenRect);
      this.readyHelper();
    }
  }, {
    key: "updateHiddenRect",
    value: function updateHiddenRect() {
      // transformer sizes update on stroke update
      var strokeWidth = this.outlineTransparent ? 0 : this.outlineSize;
      setNodeAttrs(this.hiddenRect, {
        x: -strokeWidth / 2,
        y: -strokeWidth / 2,
        width: this.width + strokeWidth,
        height: this.height + strokeWidth
      });
    }
  }, {
    key: "updateRenderable",
    value: function updateRenderable() {
      if (!this.readyToRender) {
        return;
      }

      this.updateHiddenRect();
      this.pointerPath = handlePointerPath(this.paths, {
        width: this.width,
        height: this.height,
        cornerRadius: this.cornerRadius,
        settings: this.adjust.settings,
        colorRGB1: this.colorRGB1,
        outlineSize: this.outlineSize,
        outlineColor: this.outlineColor,
        colorTransparent: this.colorTransparent,
        opacity: this.opacity,
        shadowBlur: this.shadowBlur,
        shadowColor: this.shadowColor,
        shadowOpacity: this.shadowOpacity,
        shadowOffsetX: this.shadowOffsetX,
        shadowOffsetY: this.shadowOffsetY,
        shadowTransparent: this.shadowTransparent,
        opacityOutline: this.opacityOutline,
        outlineTransparent: this.outlineTransparent
      });

      if (this.isCollage()) {
        this.setupCollage();
        removeNode(this.hiddenRect);
      } else if (this.defaultClipFunc) {
        if (!findInNodeTree(this.innerRenderable, "#".concat(this.hiddenRect.id()))) {
          addToNode(this.innerRenderable, this.hiddenRect);
        }

        this.innerRenderable.clipFunc = this.defaultClipFunc;
      }

      setNodeAttrs(this.innerRenderable, {
        strokeWidth: this.outlineTransparent ? 0 : this.outlineSize
      });
      setNodeAttrs(this.shape, {
        globalCompositeOperation: this.globalCompositeOperation
      });
    }
  }, {
    key: "readyHelper",
    value: function readyHelper() {
      this.pointerPath = handlePointerPath(this.paths, {
        width: this.width,
        height: this.height,
        cornerRadius: this.cornerRadius,
        settings: this.adjust.settings,
        colorRGB1: this.colorRGB1,
        outlineSize: this.outlineSize,
        outlineColor: this.outlineColor,
        colorTransparent: this.colorTransparent,
        opacity: this.opacity,
        opacityOutline: this.opacityOutline,
        outlineTransparent: this.outlineTransparent,
        shadowBlur: this.shadowBlur,
        shadowColor: this.shadowColor,
        shadowOpacity: this.shadowOpacity,
        shadowOffsetX: this.shadowOffsetX,
        shadowOffsetY: this.shadowOffsetY,
        shadowTransparent: this.shadowTransparent
      });
      this.readyToRender = true;
      this.visible = true;
      this.eventTarget.dispatchEvent(this.readyEvent);
    }
  }, {
    key: "isShadowApplied",
    value: function isShadowApplied() {
      return !!(this.shadowColor && !this.shadowTransparent && (this.shadowOffsetX || this.shadowOffsetY));
    } // CAUTION! Hot Function.

  }, {
    key: "renderFunc",
    value: function renderFunc(context, method) {
      var ctx = context._context;
      var isClip = method === 'clip';

      if (isClip) {
        ctx === null || ctx === void 0 ? void 0 : ctx.rect(BIG_RECT.x, BIG_RECT.y, BIG_RECT.width, BIG_RECT.height);
      }

      this.pointerPath.forEach(function (pathOptions) {
        var saturated = getSaturatedColor(pathOptions, isClip);
        ctx.fillStyle = tinycolor(saturated).setAlpha(pathOptions.calcedOpacity).toHex8String();

        if (pathOptions.lineCap) {
          ctx.lineCap = pathOptions.lineCap;
        }

        if (pathOptions.lineJoin) {
          ctx.lineJoin = pathOptions.lineJoin;
        }

        if (pathOptions.shadowColor && !pathOptions.shadowTransparent) {
          ctx.shadowColor = tinycolor(pathOptions.shadowColor).setAlpha(pathOptions.shadowOpacity / 100).toRgbString();
          ctx.shadowBlur = pathOptions.shadowBlur;

          if (pathOptions.shadowOffsetX) {
            ctx.shadowOffsetX = pathOptions.shadowOffsetX;
          }

          if (pathOptions.shadowOffsetY) {
            ctx.shadowOffsetY = pathOptions.shadowOffsetY;
          }
        }

        if (pathOptions.strokeColor && pathOptions.strokeWidth && !pathOptions.outlineTransparent) {
          var _pathOptions$opacityO;

          var strokeOp = pathOptions.outlineTransparent ? 0 : ((_pathOptions$opacityO = pathOptions.opacityOutline) !== null && _pathOptions$opacityO !== void 0 ? _pathOptions$opacityO : HUNDRED_PERCENT) / HUNDRED_PERCENT;
          ctx.strokeStyle = tinycolor(pathOptions.strokeColor).setAlpha(strokeOp).toRgbString();
          ctx.lineWidth = pathOptions.strokeWidth;
          ctx.lineJoin = 'round';

          if (isClip) {
            ctx.fill(pathOptions.path);
          }

          ctx.stroke(pathOptions.path);
        }

        if (!(method === 'fill' && isClip)) {
          ctx[method](pathOptions.path);
        }

        if (pathOptions.dashedPath) {
          ctx.globalCompositeOperation = 'destination-atop';
          ctx.strokeStyle = 'white';
          ctx.lineWidth = 10;
          ctx.setLineDash([10]);
          ctx.stroke(pathOptions.dashedPath);
        }
      }); // we need a workaround below to make shadows appear under stroke, and for multipath vector layers under the fill of other paths

      if (this.isShadowApplied()) {
        // clear the shadow
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        this.pointerPath.forEach(function (pathOptions) {
          if (pathOptions.shadowColor && (pathOptions.shadowOffsetX || pathOptions.shadowOffsetY)) {
            var saturated = getSaturatedColor(pathOptions, isClip);
            ctx.fillStyle = tinycolor(saturated).setAlpha(pathOptions.calcedOpacity).toHex8String();

            if (pathOptions.strokeColor && pathOptions.strokeWidth && !pathOptions.outlineTransparent) {
              // restroke without the shadow
              ctx.stroke(pathOptions.path);
            } // refill without the shadow


            ctx.fill(pathOptions.path);
          }
        });
      }
    }
  }]);

  return VectorLayer;
}(BaseLayer);

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var LayerProvider = /*#__PURE__*/function () {
  function LayerProvider() {
    var _defineProperty2,
        _this = this;

    _classCallCheck(this, LayerProvider);

    _defineProperty(this, "layerRegistry", {});

    _defineProperty(this, "registryListeners", {});

    _defineProperty(this, "layerClassMap", (_defineProperty2 = {}, _defineProperty(_defineProperty2, LayerType.IMAGE_LAYER, ImageLayer), _defineProperty(_defineProperty2, LayerType.COLOR_LAYER, ColorLayer), _defineProperty(_defineProperty2, LayerType.TEXT_LAYER, CustomTextLayer), _defineProperty(_defineProperty2, LayerType.GROUP_LAYER, GroupLayer), _defineProperty(_defineProperty2, LayerType.VECTOR_LAYER, VectorLayer), _defineProperty2));

    _defineProperty(this, "createOrUpdateLayer", function (serializableLayer) {
      var existingLayer = serializableLayer.id && _this.layerRegistry[serializableLayer.id];
      var layer = existingLayer ? existingLayer.layer : _this.createLayer(serializableLayer.type, serializableLayer);

      if (existingLayer) {
        return {
          promise: layer.fromJSON(_objectSpread$4(_objectSpread$4({}, layer.toJSON()), serializableLayer)),
          layer: layer
        };
      }

      return {
        layer: layer,
        promise: Promise.resolve(layer)
      };
    });
  }

  _createClass(LayerProvider, [{
    key: "restore",
    value: function restore() {
      this.layerRegistry = {};
      this.registryListeners = {};
    }
  }, {
    key: "syncLayers",
    value: function () {
      var _syncLayers = _asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee(serializableLayers, onReadyToRender) {
        var _this2 = this;

        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all(serializableLayers.map(function (serializableLayer) {
                  return _this2.createOrUpdateLayer(serializableLayer).promise;
                }));

              case 2:
                onReadyToRender();
                this.checkAndAttachEvents(onReadyToRender);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function syncLayers(_x, _x2) {
        return _syncLayers.apply(this, arguments);
      }

      return syncLayers;
    }()
  }, {
    key: "cloneLayer",
    value: function cloneLayer(id) {
      var _this$layerRegistry$i,
          _this3 = this,
          _ref2;

      var layers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var layer = (_this$layerRegistry$i = this.layerRegistry[id]) === null || _this$layerRegistry$i === void 0 ? void 0 : _this$layerRegistry$i.layer;
      if (!layer) return [];
      var dependencies = layer.dependencies.map(function (_ref) {
        var layerId = _ref.layerId;
        return _this3.cloneLayer(layerId, layers)[0];
      });
      var newLayer = this.createLayer(layer.type, _objectSpread$4(_objectSpread$4(_objectSpread$4({}, layer.toJSON()), layer instanceof ImageLayer && !layer.url && {
        image: layer.image
      }), {}, {
        dependencies: dependencies.map(function (dependency, idx) {
          return generateDependency(dependency.id, layer.dependencies[idx].type);
        }),
        id: v4()
      }));
      dependencies.length && (_ref2 = newLayer.renderable).add.apply(_ref2, _toConsumableArray(dependencies.map(function (_ref3) {
        var renderable = _ref3.renderable;
        return renderable;
      })));
      return [newLayer].concat(_toConsumableArray(dependencies), _toConsumableArray(layers));
    }
  }, {
    key: "createLayer",
    value: function createLayer(type, data) {
      var addToRegistry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var LayerClass = this.layerClassMap[type];
      var layer = new LayerClass(data);

      if (addToRegistry) {
        this.addLayerToRegistry(layer);
      }

      return layer;
    }
  }, {
    key: "getLayer",
    value: function getLayer(layerId) {
      var _this$layerRegistry$l;

      if (!layerId) {
        return;
      }

      return (_this$layerRegistry$l = this.layerRegistry[layerId]) === null || _this$layerRegistry$l === void 0 ? void 0 : _this$layerRegistry$l.layer;
    }
  }, {
    key: "getLayerAsync",
    value: function getLayerAsync(layerId, cb) {
      var registeredLayer = this.layerRegistry[layerId];
      return registeredLayer ? cb(registeredLayer.layer) : this.addToAsyncListeners(layerId, cb);
    }
  }, {
    key: "checkAndAttachEvents",
    value: function checkAndAttachEvents(onReadyToRender) {
      var _this4 = this;

      Object.values(this.layerRegistry).forEach(function (layerState) {
        if (!layerState.eventsAttached) {
          _this4.setupListeners(layerState.layer, onReadyToRender);
        }
      });
    }
  }, {
    key: "addLayerToRegistry",
    value: function addLayerToRegistry(layer) {
      this.layerRegistry[layer.id] = {
        layer: layer,
        eventsAttached: false
      };
      this.checkForAsyncListeners(layer.id);
    }
  }, {
    key: "setupListeners",
    value: function setupListeners(layer, onReadyToRender) {
      var _this5 = this;

      var layerAndDependencies = [].concat(_toConsumableArray(layer.dependencies.map(function (dependency) {
        return _this5.layerRegistry[dependency.layerId].layer;
      })), [layer]);
      var callbacksReady = callbacksResolver(function () {
        onReadyToRender();
        layer.layerReadyWithChildren();
      }, layerAndDependencies.length);
      layerAndDependencies.forEach(function (layerItem, index) {
        if (layerItem.readyToRender) {
          return callbacksReady[index]();
        }

        layerItem.onReady(callbacksReady[index]);
      });
      this.layerRegistry[layer.id].eventsAttached = true;
    }
  }, {
    key: "addToAsyncListeners",
    value: function addToAsyncListeners(layerId, cb) {
      var _this6 = this;

      this.registryListeners[layerId] = this.registryListeners[layerId] || new Map();
      /**
       * The listeners registry is registering the requests for any ids. So the layer existance is ignored here.
       * Above code is giving an API which is more like for event handlers(layer update, ready, onclick, etc.)
       * As the registration is async the layer can even not be registered at all or before it is registered, the dev
       * side can consider removing the listener. This means current function must support 2 cases of unregister
       * 1 - the layer does exist. Here we need to detach the provided listener(the return value of `cb`)
       * 2 - the layer does not exist. here we need to detach the listener from `registryListeners`
       * To cover both cases the return function is based on Map key/value logic. The Map:
       * - key is the initial callback to register any listener on layerId(regardless of existence)
       * - value is the returned value of the provided callback. This will be called(when function/listener) to
       * unregister the listener
       */

      this.registryListeners[layerId].set(cb, null);
      return function () {
        var unregister = _this6.registryListeners[layerId].get(cb); // disposing the listeneres subscription if necassary


        typeof unregister === 'function' && unregister();

        _this6.registryListeners[layerId].delete(cb);
      };
    }
  }, {
    key: "checkForAsyncListeners",
    value: function checkForAsyncListeners(layerId) {
      var _this7 = this;

      var asyncListeners = this.registryListeners[layerId];

      if (asyncListeners) {
        this.registryListeners[layerId].forEach(function (_, key) {
          _this7.registryListeners[layerId].set(key, key(_this7.getLayer(layerId)));
        });
      }
    }
  }]);

  return LayerProvider;
}();

function onHover(layerProvider, layerId, handler) {
  var layer = layerProvider.layerRegistry[layerId].layer;
  var mouseover = attachEvent(layer.innerRenderable, 'pointerover', function () {
    handler({
      isHovered: true
    });
  });
  var mouseout = attachEvent(layer.innerRenderable, 'pointerout', function () {
    handler({
      isHovered: false
    });
  });
  return function () {
    mouseover();
    mouseout();
  };
}

var KonvaProvider = /*#__PURE__*/function () {
  function KonvaProvider() {
    _classCallCheck(this, KonvaProvider);

    _defineProperty(this, "stage", null);

    _defineProperty(this, "layer", null);
  }

  _createClass(KonvaProvider, [{
    key: "destroyStage",
    value: function destroyStage(_ref) {
      var _containerDivElement$;

      var containerId = _ref.containerId;
      var containerDivElement = document.getElementById(containerId);
      (_containerDivElement$ = containerDivElement.parentNode) === null || _containerDivElement$ === void 0 ? void 0 : _containerDivElement$.removeChild(containerDivElement);
    }
  }, {
    key: "setupStage",
    value: function setupStage(_ref2) {
      var _this = this;

      var containerId = _ref2.containerId,
          zIndex = _ref2.zIndex;
      this.restore();
      var containerDivElement = document.getElementById(containerId);
      var canvasContainer = document.createElement('div');
      containerDivElement.appendChild(canvasContainer);
      canvasContainer.style.zIndex = zIndex;
      containerDivElement.tabIndex = containerDivElement.tabIndex || 1;
      this.stage = createStage({
        container: canvasContainer,
        width: containerDivElement.offsetWidth || 0,
        height: containerDivElement.offsetHeight || 0
      });
      this.layer = createLayer();
      this.stage.add(this.layer);
      return {
        updateStageSizes: function updateStageSizes(configs) {
          _this.stage && setNodeAttrs(_this.stage, configs);
        }
      };
    }
  }, {
    key: "restore",
    value: function restore() {
      if (this.stage) {
        this.stage.destroy();
        this.stage = null;
        this.layer = null;
      }
    }
  }]);

  return KonvaProvider;
}();

function treeLeftByPass(root, layersObject) {
  var _isCollage, _ref;

  var dependencies = root.dependencies;

  if (isInstanceofGroup(root.renderable) && !(root.renderable instanceof VectorWrapperGroup && !((_isCollage = (_ref = root).isCollage) !== null && _isCollage !== void 0 && _isCollage.call(_ref)))) {
    removeNodeChildren(root.renderable);
    if (root.renderable !== root.innerRenderable) addToNode(root.renderable, root.innerRenderable);
  }

  dependencies.forEach(function (dependency) {
    var dependencyLayer = layersObject[dependency.layerId];
    var renderableToAdd = isInstanceofGroup(root.renderable) ? root.renderable : getNodeParent(root.renderable);
    addToNode(renderableToAdd, treeLeftByPass(dependencyLayer, layersObject));
  });
  return root.renderable;
}

var KonvaRenderer = /*#__PURE__*/function () {
  function KonvaRenderer(provider, layerProvider) {
    _classCallCheck(this, KonvaRenderer);

    _defineProperty(this, "plugins", []);

    this.provider = provider;
    this.layerProvider = layerProvider;
  }

  _createClass(KonvaRenderer, [{
    key: "drawTree",
    value: function drawTree(layersObj) {
      var _this = this;

      var konvaLayer = this.provider.layer; // @ts-ignore

      if (isDev) window.provider = this.provider;

      _toConsumableArray(getNodeChildrenArray(konvaLayer)).forEach(function (child) {
        if (!_this.plugins.includes(child)) {
          removeNode(child);
        }
      });

      Object.values(layersObj).forEach(function (layer) {
        if (isBaseGroupLayer(layer)) {
          addToNode(konvaLayer, layersObj[layer.id].renderable);
          treeLeftByPass(layersObj[layer.id], layersObj);
        }
      });
      Object.values(this.layerProvider.layerRegistry).forEach(function (_ref2) {
        var layer = _ref2.layer;

        if (!layersObj[layer.id]) {
          layer.clearCache();
        }
      });

      if (this.plugins.length) {
        this.plugins.forEach(function (plugin) {
          if (findTransformer(konvaLayer, "#".concat(getNodeAttrs(plugin).id))) {
            nodeMoveToTop(plugin); // keep plugins on top
          } else {
            addToNode(konvaLayer, plugin);
          }
        });
      } // NOTE:: Workaround for Konva's bug


      konvaLayer._clearSelfAndDescendantCache();
    }
  }, {
    key: "render",
    value: function render() {
      if (this.provider.layer) {
        drawNode(this.provider.layer);
        this.setWaitForDraw(false);
      }
    }
  }, {
    key: "addNodePlugin",
    value: function addNodePlugin(nextPlugin) {
      var _this2 = this;

      this.plugins.push(nextPlugin);
      return function () {
        _this2.plugins = _this2.plugins.filter(function (plugin) {
          return plugin !== nextPlugin;
        });
      };
    }
  }, {
    key: "animate",
    value: function animate(layerWithFrameAttrs) {
      layerWithFrameAttrs.forEach(function (_ref3) {
        var layer = _ref3.layer,
            attrs = _ref3.attrs;
        if (!layer || !attrs) return;
        setNodeAttrs(layer.renderable, attrs);
      });
      this.render();
    } // will prevent other renders besides render() method

  }, {
    key: "waitForDraw",
    value: function waitForDraw() {
      this.setWaitForDraw(true);
    }
  }, {
    key: "setWaitForDraw",
    value: function setWaitForDraw(value) {
      if (this.provider.layer) {
        //  konva is doing unexpected batchDraws from Trasnformer
        //  setting _waitingForDraw = true, will prevent ALL batchDraws on Layer.
        this.provider.layer._waitingForDraw = value;
      }
    }
  }]);

  return KonvaRenderer;
}();

function onStageClick(konvaProvider, handler) {
  var stage = konvaProvider.stage;
  return attachEvent(stage, 'click', function (event) {
    handler({
      isTargetStage: event.target === stage
    });
  });
}

function onMousedown(layerProvider, id, handler) {
  var layerObject = layerProvider.layerRegistry[id];
  return attachEvent(layerObject.layer.innerRenderable, 'mousedown', function (event) {
    // do not propagate event to canvas container div
    event.evt.stopPropagation();
    handler(event.evt);
  });
}

function onDoubleClick(layerProvider, id, handler) {
  var layer = layerProvider.layerRegistry[id].layer;
  return attachEvent(layer.innerRenderable, 'dblclick', function () {
    return handler();
  });
}

function onContextMenu(layerProvider, id, handler) {
  var layer = layerProvider.layerRegistry[id].layer;
  return attachEvent(layer.innerRenderable, 'contextmenu', function (event) {
    event.evt.preventDefault();
    var _event$evt = event.evt,
        top = _event$evt.pageY,
        left = _event$evt.pageX;
    handler({
      top: top,
      left: left
    });
  });
}

function onStageMousedown(konvaProvider, handler) {
  var stage = konvaProvider.stage;
  return attachEvent(stage, 'mousedown', function (event) {
    handler({
      isTargetStage: event.target === stage,
      event: event.evt
    });
  });
}

var getEventTarget = function getEventTarget(e) {
  var target = e.target;

  if (getNodeAttrs(target).name === 'back') {
    var nodes = getNodes(getNodeParent(target));

    if (nodes.length === 1) {
      var _nodes = _slicedToArray(nodes, 1);

      target = _nodes[0];
    }
  }

  return target;
};

var onStageMouseMove = function onStageMouseMove(konvaProvider, layerProvider, handler) {
  var _konvaProvider$stage;

  var handlerWrapper = function handlerWrapper(event) {
    var _layerProvider$layerR;

    var layerId = getEventTarget(event).id();
    handler((_layerProvider$layerR = layerProvider.layerRegistry[layerId]) === null || _layerProvider$layerR === void 0 ? void 0 : _layerProvider$layerR.layer.toJSON());
  };

  (_konvaProvider$stage = konvaProvider.stage) === null || _konvaProvider$stage === void 0 ? void 0 : _konvaProvider$stage.on('mousemove', handlerWrapper);
  return function () {
    var _konvaProvider$stage2;

    return (_konvaProvider$stage2 = konvaProvider.stage) === null || _konvaProvider$stage2 === void 0 ? void 0 : _konvaProvider$stage2.off('mousemove', handlerWrapper);
  };
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var getRotationAngleText = function getRotationAngleText(rotation) {
  var angle = degreeToRadian(rotation);
  var calculatedAngle = radianToDegree(Math.asin(Math.sin(angle)));
  var sign = Math.sign(Math.sin(angle));

  if (Math.sign(Math.cos(angle)) <= 0) {
    calculatedAngle = sign * (180 - sign * calculatedAngle);
  }

  return "   ".concat(Math.round(calculatedAngle), "\u02DA   ");
};

var addBadges = function addBadges(transformer, configs) {
  var name = getNodeActiveAnchor(transformer);

  if (!name) {
    return;
  }

  var anchor = findNodeFirstIdentifier(transformer, ".".concat(name));
  var label = findNodeFirstIdentifier(transformer, 'Label');

  var _getNodeAttrs = getNodeAttrs(anchor),
      anchorX = _getNodeAttrs.x,
      anchorY = _getNodeAttrs.y,
      anchorWidth = _getNodeAttrs.width,
      anchorHeight = _getNodeAttrs.height;

  var scale = getNodeAttrs(getNodeStage(transformer)).scaleX || 1;
  var rotationBadgeGap = 12;
  var transformerSize = {
    height: getNodeAttrs(transformer).height / scale,
    width: getNodeAttrs(transformer).width / scale
  };
  var getTooltipParams = configs.getTooltipParams;
  var isRotation = name === 'rotater';
  var x = anchorX + anchorWidth / 2 + rotationBadgeGap;
  var y = isRotation ? anchorY - anchorHeight / 2 - rotationBadgeGap : anchorY + anchorHeight / 2 + rotationBadgeGap;
  var text = isRotation ? getRotationAngleText(getNodeAttrs(transformer).rotation) : function () {
    var _getTooltipParams = getTooltipParams(transformerSize),
        width = _getTooltipParams.width,
        height = _getTooltipParams.height,
        unit = _getTooltipParams.unit;

    return "   ".concat(width, " x ").concat(height, " ").concat(unit, "  ");
  }();

  if (label) {
    setNodeAttrs(label, {
      x: x,
      y: y
    });
    var labelText = findNodeFirstIdentifier(transformer, '#label-text');
    setNodeAttrs(labelText, {
      text: text
    });
  } else {
    // add new if not exist
    var newLabel = createLabel({
      id: 'transform-badge',
      x: x,
      y: y
    });
    attachEventOnce(transformer, 'transformend', function () {
      newLabel.destroy();
    });
    addNodeIntoLabel(newLabel, createTag({
      id: 'label-tag',
      fill: configs.tooltipBackgroundColor,
      cornerRadius: 2,
      opacity: 0.5
    }));
    addNodeIntoLabel(newLabel, createText({
      id: 'label-text',
      text: text,
      fontSize: 10,
      // TODO-THEME
      fill: configs.tooltipTextColor,
      height: 16,
      lineHeight: 1.8
    }));
    addNodeIntoTransformer(transformer, newLabel);
  }
};

var getAnchorsOffsetDiffs = function getAnchorsOffsetDiffs(offset) {
  return {
    'middle-right': {
      offsetX: -offset,
      offsetY: 0
    },
    'middle-left': {
      offsetX: offset,
      offsetY: 0
    },
    'top-center': {
      offsetX: 0,
      offsetY: offset
    },
    'bottom-center': {
      offsetX: 0,
      offsetY: -offset
    }
  };
};

var changeMiddleAnchorsStyle = function changeMiddleAnchorsStyle(tr, anchorsNames) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var anchorsOffsetDiff = getAnchorsOffsetDiffs(offset);
  anchorsNames.forEach(function (anchorName) {
    var _anchorsOffsetDiff$an, _anchorsOffsetDiff$an2;

    var anchor = findNode(tr, ".".concat(anchorName));
    var isOnSides = anchorName.includes('middle-');
    var sizeDiff = {
      w: isOnSides ? TRANSFORMER_MIDDLE_ANCHOR_MIN : TRANSFORMER_MIDDLE_ANCHOR_MAX,
      h: isOnSides ? TRANSFORMER_MIDDLE_ANCHOR_MAX : TRANSFORMER_MIDDLE_ANCHOR_MIN
    };
    setNodeAttrs(anchor, {
      width: sizeDiff.w,
      height: sizeDiff.h,
      anchorCornerRadius: 3,
      offsetX: sizeDiff.w / 2 + ((_anchorsOffsetDiff$an = anchorsOffsetDiff[anchorName]) === null || _anchorsOffsetDiff$an === void 0 ? void 0 : _anchorsOffsetDiff$an.offsetX),
      offsetY: sizeDiff.h / 2 + ((_anchorsOffsetDiff$an2 = anchorsOffsetDiff[anchorName]) === null || _anchorsOffsetDiff$an2 === void 0 ? void 0 : _anchorsOffsetDiff$an2.offsetY)
    });
  });
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var rotateIconSize = 10;

var addRotateIcon = function addRotateIcon(transformer, fillColor) {
  var _getNodes;

  if (!((_getNodes = getNodes(transformer)) !== null && _getNodes !== void 0 && _getNodes.length)) {
    return;
  }

  var rotater = findRect(transformer, '.rotater');
  var rotaterIcon = findRect(transformer, '#rotater-icon');
  setNodeAttrs(rotater, {
    width: TRANSFORMER_ROTATER_BOX_SIZE,
    height: TRANSFORMER_ROTATER_BOX_SIZE,
    offsetX: TRANSFORMER_ROTATER_BOX_SIZE_OFFSET,
    offsetY: TRANSFORMER_ROTATER_BOX_SIZE_OFFSET
  });

  var _getNodeAttrs = getNodeAttrs(transformer),
      transformerWidth = _getNodeAttrs.width,
      rotateAnchorOffset = _getNodeAttrs.rotateAnchorOffset;

  var rotatePosX = transformerWidth / 2 - rotateIconSize / 2;
  var rotatePosY = -rotateAnchorOffset - rotateIconSize / 2;
  var initialRotaterIconConfig = {
    x: rotatePosX,
    y: rotatePosY
  };

  if (rotaterIcon) {
    setNodeAttrs(rotaterIcon, initialRotaterIconConfig);
  } else {
    var iconPath = createPath(_objectSpread$3({
      fill: fillColor,
      id: 'rotater-icon',
      listening: false,
      // eslint-disable-next-line
      data: 'M8.99609 0.628906C9.10547 0.628906 9.19531 0.664062 9.26562 0.734375C9.33594 0.804688 9.37109 0.894531 9.37109 1.00391V3.875H8.76172C8.75391 3.875 8.75 3.875 8.75 3.875C8.75 3.875 8.74609 3.875 8.73828 3.875H6.5C6.39844 3.875 6.30859 3.83984 6.23047 3.76953C6.16016 3.69141 6.125 3.60156 6.125 3.5C6.125 3.39844 6.16016 3.3125 6.23047 3.24219C6.30859 3.16406 6.39844 3.125 6.5 3.125H8.12891C8.00391 2.92969 7.84766 2.73047 7.66016 2.52734C7.46484 2.31641 7.23438 2.12891 6.96875 1.96484C6.71094 1.79297 6.41797 1.65234 6.08984 1.54297C5.76172 1.43359 5.39844 1.37891 5 1.37891C4.5 1.37891 4.05859 1.46094 3.67578 1.625C3.28516 1.78906 2.94922 1.98828 2.66797 2.22266C2.38672 2.45703 2.15625 2.70703 1.97656 2.97266C1.79688 3.23047 1.67188 3.45312 1.60156 3.64062C1.5625 3.73438 1.49219 3.80469 1.39062 3.85156C1.29688 3.89062 1.20312 3.89062 1.10938 3.85156C1.01562 3.8125 0.945312 3.74609 0.898438 3.65234C0.859375 3.55078 0.859375 3.45312 0.898438 3.35938C0.992188 3.13281 1.14453 2.86328 1.35547 2.55078C1.56641 2.23828 1.83984 1.94141 2.17578 1.66016C2.51953 1.37109 2.92578 1.125 3.39453 0.921875C3.86328 0.726563 4.39844 0.628906 5 0.628906C5.44531 0.628906 5.85547 0.683594 6.23047 0.792969C6.60547 0.910156 6.94141 1.05859 7.23828 1.23828C7.54297 1.41797 7.80859 1.62109 8.03516 1.84766C8.26953 2.07422 8.46484 2.30078 8.62109 2.52734V1.00391C8.62109 0.894531 8.65625 0.804688 8.72656 0.734375C8.80469 0.664062 8.89453 0.628906 8.99609 0.628906ZM1.23828 6.125H0.628906V8.99609C0.628906 9.10547 0.664062 9.19531 0.734375 9.26562C0.804688 9.33594 0.894531 9.37109 1.00391 9.37109C1.10547 9.37109 1.19141 9.33594 1.26172 9.26562C1.33984 9.19531 1.37891 9.10547 1.37891 8.99609V7.47266C1.53516 7.69922 1.73047 7.92578 1.96484 8.15234C2.19141 8.37891 2.45312 8.58203 2.75 8.76172C3.05469 8.94141 3.39453 9.08984 3.76953 9.20703C4.14453 9.31641 4.55469 9.37109 5 9.37109C5.60156 9.37109 6.13672 9.27344 6.60547 9.07812C7.07422 8.875 7.47656 8.63281 7.8125 8.35156C8.15625 8.0625 8.43359 7.76172 8.64453 7.44922C8.85547 7.13672 9.00781 6.86719 9.10156 6.64062C9.14062 6.54688 9.13672 6.45312 9.08984 6.35938C9.05078 6.25781 8.98438 6.1875 8.89062 6.14844C8.79688 6.10938 8.69922 6.11328 8.59766 6.16016C8.50391 6.19922 8.4375 6.26562 8.39844 6.35938C8.32812 6.54688 8.20312 6.76953 8.02344 7.02734C7.84375 7.29297 7.61328 7.54297 7.33203 7.77734C7.05078 8.01172 6.71484 8.21094 6.32422 8.375C5.94141 8.53906 5.5 8.62109 5 8.62109C4.60156 8.62109 4.23828 8.56641 3.91016 8.45703C3.58203 8.34766 3.28516 8.21094 3.01953 8.04688C2.76172 7.875 2.53516 7.68359 2.33984 7.47266C2.15234 7.26953 1.99609 7.07031 1.87109 6.875H3.5C3.60156 6.875 3.6875 6.83984 3.75781 6.76953C3.83594 6.69141 3.875 6.60156 3.875 6.5C3.875 6.39844 3.83594 6.3125 3.75781 6.24219C3.6875 6.16406 3.60156 6.125 3.5 6.125H1.26172C1.25391 6.125 1.25 6.125 1.25 6.125C1.25 6.125 1.24609 6.125 1.23828 6.125Z'
    }, initialRotaterIconConfig));
    addNodeIntoTransformer(transformer, iconPath);
  }
};

var changeTrBorderStyle = function changeTrBorderStyle(tr) {
  var optional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var back = findShape(tr, '.back');

  if (!back) {
    return;
  }

  var _getNodeAttrs = getNodeAttrs(back),
      strokeWidth = _getNodeAttrs.strokeWidth;

  back.sceneFunc(function (ctx, shape) {
    var color = optional.color,
        _optional$shadowBlur = optional.shadowBlur,
        shadowBlur = _optional$shadowBlur === void 0 ? 0 : _optional$shadowBlur,
        _optional$shadowColor = optional.shadowColor,
        shadowColor = _optional$shadowColor === void 0 ? '' : _optional$shadowColor,
        _optional$showDefault = optional.showDefaultBorder,
        showDefaultBorder = _optional$showDefault === void 0 ? false : _optional$showDefault,
        _optional$offset = optional.offset,
        offset = _optional$offset === void 0 ? 0 : _optional$offset;
    var shapeWidth = getNodeAttrs(shape).width;
    var shapeHeight = getNodeAttrs(shape).height;
    var rectOffset = strokeWidth - offset;
    ctx.shadowBlur = shadowBlur;
    ctx.shadowColor = shadowColor;
    ctx.strokeStyle = color;

    if (!showDefaultBorder) {
      // draws white rect
      ctx.beginPath();
      ctx.lineWidth = strokeWidth;
      ctx.rect(rectOffset, rectOffset, shapeWidth + offset, shapeHeight + offset);
      ctx.stroke();
    }

    ctx.beginPath();
    ctx.rect(-offset, -offset, shapeWidth + 2 * offset, shapeHeight + 2 * offset);
    ctx.stroke();
    ctx.fillStrokeShape(shape);
  });
};

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkBxgGLhx9B3mFAAADeklEQVRYw+2WzWtUVxjGf/djPjJDDJNxAsZiC4kITQ1VaCHblnbjsmCpEIsUwUXrn+Cif4ILd4VOYikI0ZWbltSFkEhCa6kNIqaYaieBSUxMhmZmMveep4u5NzN3PpLSLp3nhfm45z3vc59z3vO+B3rooYceXgNYLd916H9Ga4piNw1Y3qdYWG2OVpPZ2JH/reGtIEoLnYWNgyuvfAEXpyWIXR/FxSVGLPjltJHZOLjlC/L2YwBuE4mDk5zatgdu4QcCLSysMXv2zJEJ94z9lnXMSoF2tWZWvIc78x8+XDII7fs62+eT3+Lg4EeX2cIhQVqS5G1cJIGLg0ts5WzlhllTF5jVyo2Vs8QC78TGRXmSRJoETl1BfZ1sbFzi2gbAX/9i6BZm9b3cNfcjgL21X5//pIX08sBOEo5URrff//sD690T8WMA3o/rXw8vYhfP577BAbAG2MPDYEIFNjFSZCTpuzlJXvFqOS8jmdK9uYmnwTK02cTTe3OmJMmU88Wr8oLZIkOKWJBA+wRpspKEbs4HC1Cdmcu+6hY8tOyrmTlTrc+4OY8kiSzpTgRH6wRo+oFUfPz2i8OChzb2ovhYmn6AAoKjDYJwDxzi9Gk9fDD52/djntOcB4Olj5+PVN8w8Jf9R+KHE5v9zaOu/9nS9Hh4uqwcZfbwo3vQpCBqgzvXF18+kx9JIP/ls+uLgzvt3gcpSKnYeoj7qvlHn7xjJ0HV0qPdP8tb0JdJvdl/2kqAqcz8/vnpcqK1PlhD7HZSkGtVcHyjtCrJbN6/e+XUOCcZZYQRRjl5avzulc37MlJp9fhGm4JcQ4HNAShkbxdAWrpzbvZJiSrlwKpPSudml+5IcLtQyB5eBbsoQCi/KMn7+UuGGSJLhgxZhhj+5St5Un6x4x7kOqdprvMmTy1I8pYvk6GfNGn6ySxflidNLXTZ5NwB56ArvMIlUiRIkCpcqtecbmjOouZSkdXB8LYmiRPfmjw4vES2USrC1uAQI0GSJLGwkgdZJwweHlX2qOEDDjHiJHBxg47Q8DbUqFChSq1est2mIZ8a4EUIGhQmqPvhkxrCb+lqdc8aPibsB26EG3yclndq0IfTDD5g8NpaoxA+PrXOBKAWydF3UzDNwsNv0RnVaxoEVuTT6hI+nBo2Ug7xayxmh2tLt4nRy8y/8fqvl58eeujh9cM/bu/RT6Yi9OwAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjAtMDctMjRUMDY6NDY6MjIrMDA6MDCON/u1AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIwLTA3LTI0VDA2OjQ2OjIyKzAwOjAw/2pDCQAAAABJRU5ErkJggg==";

var _excluded = ["borderStroke", "anchorStroke"];
var anchorTypes = {
  text: [Anchors.TOP_LEFT, Anchors.TOP_RIGHT, Anchors.BOTTOM_LEFT, Anchors.BOTTOM_RIGHT, Anchors.MIDDLE_RIGHT],
  textWithGroup: [Anchors.TOP_LEFT, Anchors.TOP_RIGHT, Anchors.BOTTOM_LEFT, Anchors.BOTTOM_RIGHT],
  default: [Anchors.TOP_LEFT, Anchors.TOP_RIGHT, Anchors.BOTTOM_LEFT, Anchors.BOTTOM_RIGHT, Anchors.MIDDLE_LEFT, Anchors.MIDDLE_RIGHT, Anchors.BOTTOM_CENTER, Anchors.TOP_CENTER],
  switchableAnchors: [Anchors.TOP_CENTER, Anchors.TOP_LEFT, Anchors.MIDDLE_LEFT, Anchors.MIDDLE_RIGHT, Anchors.BOTTOM_LEFT, Anchors.BOTTOM_CENTER, Anchors.BOTTOM_RIGHT],
  middleAnchors: [Anchors.TOP_CENTER, Anchors.BOTTOM_CENTER, Anchors.MIDDLE_RIGHT, Anchors.MIDDLE_LEFT],
  noAnchors: []
};

var hideAnchorsWhenSmall = function hideAnchorsWhenSmall(transformer, anchorFill) {
  // 2 * half TRANSFORMER_ANCHOR and one TRANSFORMER_MIDDLE_ANCHOR
  var minSize = TRANSFORMER_ANCHOR_SIZE + TRANSFORMER_MIDDLE_ANCHOR_MAX;
  var trWidth = getNodeAttrs(transformer).width;
  var trHeight = getNodeAttrs(transformer).height;
  var hide = Math.abs(trWidth) < minSize || Math.abs(trHeight) < minSize;
  var anchorsNames = intersection_1(getNodeAttrs(transformer).enabledAnchors, anchorTypes.switchableAnchors);
  anchorsNames.forEach(function (anchorName) {
    var anchor = findShape(transformer, ".".concat(anchorName)); // change color to transparent, to keep functionality of resizing
    // NOTE: opacity is not used because of performance issue in safari

    if (hide) {
      anchor.fill('transparent');
      anchor.strokeEnabled(false);
    } else {
      anchor.fill(anchorFill);
      anchor.strokeEnabled(true);
    }
  });
}; // Check is there free grid selected with transformer and is there are selected cell inside free grid


var hasSelectedNode = function hasSelectedNode(transformer) {
  return getNodes(transformer).length > 1;
};

var customizeAnchorStyle = function customizeAnchorStyle(transformer, configs) {
  var offset = TRANSFORMER_BORDER_OFFSET; // eslint-disable-next-line

  transformer.update = function () {
    var _getNodeAttrs = getNodeAttrs(transformer),
        rotateEnabled = _getNodeAttrs.rotateEnabled;

    if (hasSelectedNode(transformer)) {
      setNodeAttrs(transformer, {
        borderDash: [6]
      });
    } else {
      setNodeAttrs(transformer, {
        borderDash: undefined
      });
    }

    Konva.Transformer.prototype.update.apply(transformer);
    changeMiddleAnchorsStyle(transformer, anchorTypes.middleAnchors, offset);
    changeTrBorderStyle(transformer, {
      offset: offset,
      color: 'rgb(0, 0, 0, 0)'
    });

    if (rotateEnabled) {
      addRotateIcon(transformer, configs.rotaterIconFill);
    } else {
      removeNode(findRect(transformer, '#rotater-icon'));
    }

    addBadges(transformer, {
      tooltipTextColor: configs.tooltipTextColor,
      getTooltipParams: configs.getTooltipParams,
      tooltipBackgroundColor: configs.tooltipBackgroundColor
    });
    hideAnchorsWhenSmall(transformer, configs.anchorFill);
  };

  var rotater = findRect(transformer, '.rotater');
  detachEventAllHandlers(rotater, 'mouseenter');
  setNodeAttrs(rotater, {
    fill: configs.rotaterFill,
    stroke: configs.rotaterStroke
  });
  attachEvent(rotater, 'mouseover', function () {
    getNodeContainer(getNodeStage(transformer)).style.setProperty('cursor', "-webkit-image-set(url(".concat(img, ") 2x,url(").concat(img, ") 3x) 12 12,auto"));
  });
  attachEvent(rotater, 'mouseout', function () {
    getNodeContainer(getNodeStage(transformer)).style.setProperty('cursor', 'default');
  });
  transformer.update();
};

var createTransformer = function createTransformer(_ref) {
  var borderStroke = _ref.borderStroke,
      anchorStroke = _ref.anchorStroke,
      rest = _objectWithoutProperties(_ref, _excluded);

  var transformer = createTransformer$1({
    id: DEFAULT_TR,
    anchorStroke: anchorStroke,
    anchorFill: rest.anchorFill,
    borderStroke: borderStroke,
    anchorSize: TRANSFORMER_ANCHOR_SIZE,
    anchorCornerRadius: 50,
    resizeEnabled: true,
    rotateEnabled: true,
    borderStrokeWidth: 2,
    anchorStrokeWidth: 2,
    rotateAnchorOffset: 20,
    rotationSnaps: [0, 90, 180, 270, 45, -45, 135, 225],
    rotationSnapTolerance: 5,
    shouldOverdrawWholeArea: true
  });
  customizeAnchorStyle(transformer, rest);
  return transformer;
};

// instead of flipping by X axis Konva flips the item by Y axis and rotates by 180 degrees.
// as currently the user can't scale and rotate at the same time, this case is the actual bug
// Currently, texts do not support flip functionality.

var manageTransformerHorizontalFlip = function manageTransformerHorizontalFlip(node) {
  var rotatedAngle = 180;

  var _getNodeAttrs = getNodeAttrs(node),
      rotation = _getNodeAttrs.rotation,
      scaleX = _getNodeAttrs.scaleX,
      scaleY = _getNodeAttrs.scaleY;

  var newAngle = rotation < 0 ? rotation + rotatedAngle : rotation - rotatedAngle;
  var updatedAttributes = {
    scaleX: -scaleX,
    scaleY: -scaleY,
    rotation: newAngle
  };
  setNodeAttrs(node, updatedAttributes);
  return updatedAttributes;
};

var abs = Math.abs;

var getPotentialBaseGroup = function getPotentialBaseGroup(layerProvider, _ref, baseGroups, currentIndex, heights) {
  var y = _ref.y,
      height = _ref.height,
      rotation = _ref.rotation;
  return baseGroups.find(function (_ref2, findIndex) {
    var renderable = _ref2.renderable,
        index = _ref2.meta.index;
    var isRotated = [90, -90, 180, -180].includes(rotation);
    var transformerRotaterSize = TRANSFORMER_ROTATER_BOX_SIZE + TRANSFORMER_ROTATER_BOX_SIZE_OFFSET;
    var yToCompare = index > currentIndex ? y + transformerRotaterSize * Number(!isRotated) : y + height - transformerRotaterSize * Number(isRotated);

    var _getNodeAttrs = getNodeAttrs(renderable),
        baseY = _getNodeAttrs.absolutePosition.y,
        baseScaleY = _getNodeAttrs.absoluteScale.y;

    var maxY = baseY + heights[findIndex] * baseScaleY;
    return yToCompare && yToCompare > baseY && yToCompare < maxY;
  });
};

var draggingElements = {
  addedLayers: [],
  fromBaseGroupIndex: -1,
  toBaseGroupIndex: -1,
  zIndexes: [],
  heights: [],
  baseGroups: [],
  dragStart: function dragStart(layerProvider, nodes, layers, currentBaseGroupIndex, topLevelLayers, evt) {
    var _this = this;

    this.baseGroups = layers.filter(isBaseGroupLayer);
    var allLayersAreInTopLevel = nodes.every(function (node) {
      return topLevelLayers.includes(getNodeAttrs(node).id);
    });
    this.addedLayers = [];
    nodes.forEach(function (node) {
      if (evt.shiftKey) {
        var isVertical = abs(evt.movementY) > abs(evt.movementX);
        node.dragBoundFunc(function (_ref3) {
          var x = _ref3.x,
              y = _ref3.y;
          var _getNodeAttrs$absolut = getNodeAttrs(node).absolutePosition,
              _x = _getNodeAttrs$absolut.x,
              _y = _getNodeAttrs$absolut.y;
          if (isVertical) return {
            x: _x,
            y: y
          };
          return {
            x: x,
            y: _y
          };
        });
      } else {
        node.dragBoundFunc(function (_) {
          return _;
        });
      }

      if (allLayersAreInTopLevel && evt.altKey) {
        var _this$addedLayers;

        var _layerProvider$cloneL = layerProvider.cloneLayer(getNodeAttrs(node).id),
            _layerProvider$cloneL2 = _toArray(_layerProvider$cloneL),
            parentLayer = _layerProvider$cloneL2[0],
            dependencies = _layerProvider$cloneL2.slice(1);

        _this.baseGroups[currentBaseGroupIndex].renderable.add(parentLayer.renderable);

        (_this$addedLayers = _this.addedLayers).push.apply(_this$addedLayers, _toConsumableArray([].concat(_toConsumableArray(dependencies), [parentLayer]).map(function (layer) {
          return layer.toJSON();
        })));
      }
    });

    if (allLayersAreInTopLevel) {
      this.zIndexes = nodes.map(function (node) {
        return getNodeAttrs(node).zIndex;
      });
      this.heights = this.baseGroups.map(function (_ref4) {
        var id = _ref4.id;
        return getClientRect(layerProvider.layerRegistry[id].layer.renderable).height;
      });
      this.toBaseGroupIndex = currentBaseGroupIndex;
      this.fromBaseGroupIndex = currentBaseGroupIndex;
    }
  },
  dragMove: function dragMove(layerProvider, nodes, transformerParams) {
    var _this2 = this;

    if (this.toBaseGroupIndex === -1) return;
    var newBase = getPotentialBaseGroup(layerProvider, transformerParams, this.baseGroups, this.toBaseGroupIndex, this.heights);

    if (newBase && newBase.meta.index !== this.toBaseGroupIndex) {
      nodes.forEach(function (node, idx) {
        var _getNodeAttrs2 = getNodeAttrs(node),
            absolutePosition = _getNodeAttrs2.absolutePosition;

        addToNode(newBase.renderable, node);
        _this2.toBaseGroupIndex = newBase.meta.index;
        node.setAbsolutePosition(absolutePosition);

        if (_this2.toBaseGroupIndex === _this2.fromBaseGroupIndex) {
          setNodeAttrs(node, {
            zIndex: _this2.zIndexes[idx]
          });
        }
      });
    }
  },
  dragEnd: function dragEnd() {
    this.fromBaseGroupIndex = -1;
    this.toBaseGroupIndex = -1;
    this.zIndexes = [];
    this.heights = [];
    this.addedLayers = [];
  }
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getWithInnerRenderableIdUniq(layerProvider, id) {
  var innerRenderable = layerProvider.layerRegistry[id].layer.innerRenderable;
  var innerRenderableId = innerRenderable && getNodeAttrs(innerRenderable).id;
  if (innerRenderableId && innerRenderableId !== id) return [id, innerRenderableId];
  return [id];
} // as shouldOverDrawWholeArea set true on transformer and transformer has higher zIndex than element, we are checking and firing events on corresponding elements


var eventsToFireOnIntersections = ['mousedown', 'click', 'mouseup', 'dblclick', 'contextmenu'];

var setupTransformerBackShapeEvents = function setupTransformerBackShapeEvents(layerProvider, transformer, options) {
  var back = findTransformerBackShape(transformer);
  eventsToFireOnIntersections.forEach(function (type) {
    return attachEvent(back, type, function (event) {
      var orderedIds = options.getOrderedLayerIds().reduce(function (acc, id) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(getWithInnerRenderableIdUniq(layerProvider, id)));
      }, []);
      var idsWithCropGroupDependencies = options.getLayersIdsWithCropGroupDependencies();
      var transformerNodesIds = getNodes(transformer).reduce(function (acc, node) {
        var id = idsWithCropGroupDependencies[getNodeAttrs(node).id];
        return [].concat(_toConsumableArray(acc), _toConsumableArray(getWithInnerRenderableIdUniq(layerProvider, id)));
      }, []);

      var getUnderTransformerCoefficient = function getUnderTransformerCoefficient(id) {
        return Number(transformerNodesIds.includes(id));
      }; // adding stage position to pointer (x, y), as the stage(camera) also can be moved to some (x, y)


      var stagePosition = calcStagePosition(getNodeStage(transformer), options.getHasVerticalScrollParams(), true);
      var possiblePointerPosition = getStagePointerPosition(getNodeStage(transformer)) || {
        x: 0,
        y: 0
      };
      var pointerPosition = {
        x: possiblePointerPosition.x - stagePosition.x,
        y: possiblePointerPosition.y - stagePosition.y
      };
      var topNode = options.getSelectableElementsAbs().reverse().reduce(function (currentNode, layer) {
        var node = layerProvider.layerRegistry[idsWithCropGroupDependencies[layer.id]].layer.innerRenderable;

        if (hasIntersectionWithPoint(layer, pointerPosition || {
          x: 0,
          y: 0
        })) {
          if (!currentNode) {
            return node;
          }

          var _getNodeAttrs = getNodeAttrs(node),
              nodeId = _getNodeAttrs.id;

          var _getNodeAttrs2 = getNodeAttrs(currentNode),
              currentNodeId = _getNodeAttrs2.id;

          var nodeUnderTransformerCoefficient = getUnderTransformerCoefficient(nodeId);
          var currentNodeUnderTransformerCoefficient = getUnderTransformerCoefficient(currentNodeId); // if both are under or both not transformer or event type is click compare by zIndex

          if (nodeUnderTransformerCoefficient === currentNodeUnderTransformerCoefficient || type === 'click') {
            return orderedIds.indexOf(nodeId) < orderedIds.indexOf(currentNodeId) ? node : currentNode;
          } // if only one of the elements is under transformer it has priority (expect click event)


          return nodeUnderTransformerCoefficient > currentNodeUnderTransformerCoefficient ? node : currentNode;
        }

        return currentNode;
      }, null);

      if (!topNode) {
        return;
      }

      fireNodeEvent(topNode, type, _objectSpread$2(_objectSpread$2({}, event), {}, {
        target: topNode
      }));
    });
  });
};

var calculateWidth = function calculateWidth(width, scale) {
  return Math.fround(width * scale);
}; // as view is very sensitive to width rounding it.;


var setupTransformerInteractions = function setupTransformerInteractions(layerProvider, transformer, options) {
  setupTransformerBackShapeEvents(layerProvider, transformer, {
    getHasVerticalScrollParams: options.getHasVerticalScrollParams,
    getOrderedLayerIds: options.getOrderedLayerIds,
    getSelectableElementsAbs: options.getSelectableElementsAbs,
    getLayersIdsWithCropGroupDependencies: options.getLayersIdsWithCropGroupDependencies
  });
  transformer.on('mousedown', function (event) {
    // do not propagate event to canvas container div
    event.evt.stopPropagation();
    options.onMousedown();
  });
  transformer.on('dragstart', function (_ref) {
    var evt = _ref.evt;
    options.onDragstart();
    var layersArray = Object.values(layerProvider.layerRegistry).map(function (_ref2) {
      var layer = _ref2.layer;
      return layer;
    });
    draggingElements.dragStart(layerProvider, getNodes(transformer), layersArray, options.getCurrentBaseGroupIndex(), options.getChangableIds(), evt);
  });
  attachEvent(transformer, 'dragmove', function () {
    var _getClientRect = getClientRect(transformer),
        y = _getClientRect.y,
        height = _getClientRect.height;

    var _getNodeAttrs3 = getNodeAttrs(transformer),
        rotation = _getNodeAttrs3.rotation;

    draggingElements.dragMove(layerProvider, getNodes(transformer), {
      y: y,
      height: height,
      rotation: rotation
    });
  }); // do not flip text with transformer

  transformer.on('transformstart', function () {
    options.onTransformStart();
    var flipEnabled = getNodes(transformer).every(function (node) {
      return !options.disableFlip(getNodeAttrs(node).id);
    });
    transformer.flipEnabled(flipEnabled);
    transformer.boundBoxFunc(function (oldBox, newBox) {
      if (getNodes(transformer).find(isInstanceofText)) {
        var minWH = 1;
        var checkPos = newBox.height < minWH && newBox.height < oldBox.height || newBox.width < minWH && newBox.width < oldBox.width;
        return checkPos ? oldBox : newBox;
      }

      return newBox;
    });
  }); // change width of text box, not size of text

  transformer.on('transform', function () {
    transformer.nodes().forEach(function (node) {
      var _getNodeAttrs4 = getNodeAttrs(node),
          id = _getNodeAttrs4.id;

      var innerRenderable = layerProvider.layerRegistry[id].layer.innerRenderable;

      if (isInstanceofText(innerRenderable)) {
        var nodesToChange = isInstanceofGroup(node) ? node.children : [node];
        var scale = getNodeAttrs(node).scaleX;

        var _getNodeAttrs5 = getNodeAttrs(innerRenderable),
            height = _getNodeAttrs5.height;

        if (['middle-right', 'middle-left'].includes(transformer.getActiveAnchor())) {
          nodesToChange === null || nodesToChange === void 0 ? void 0 : nodesToChange.forEach(function (nodeToChange) {
            setNodeAttrs(nodeToChange, {
              width: calculateWidth(getNodeAttrs(nodeToChange).width, scale),
              scaleX: 1,
              scaleY: 1
            });

            if (!isInstanceofText(nodeToChange)) {
              setNodeAttrs(nodeToChange, {
                height: height,
                scaleY: 1
              });
            }
          });
          setNodeAttrs(node, {
            scaleX: 1
          });
        }
      }
    });
  });
  transformer.on('dragend transformend', function () {
    options.onTransformEnd();
    updateTransformer(transformer);
    var patches = getNodes(transformer).reduce(function (result, node) {
      var _getNodeAttrs6 = getNodeAttrs(node),
          id = _getNodeAttrs6.id,
          x = _getNodeAttrs6.x,
          y = _getNodeAttrs6.y,
          scaleX = _getNodeAttrs6.scaleX,
          scaleY = _getNodeAttrs6.scaleY,
          rotation = _getNodeAttrs6.rotation;

      var selected = layerProvider.layerRegistry[id].layer;
      var innerRenderable = selected.innerRenderable;

      var _getNodeAttrs7 = getNodeAttrs(innerRenderable),
          width = _getNodeAttrs7.width,
          height = _getNodeAttrs7.height;

      if (!selected) return result;
      var baseAttrs = {
        id: id,
        x: x,
        y: y,
        rotation: rotation
      }; // change font size instead of scale

      if (isInstanceofText(innerRenderable)) {
        var text = selected.toJSON();
        var scaledAttrs = changeScaleToFontSize(_objectSpread$2(_objectSpread$2(_objectSpread$2({}, text), baseAttrs), {}, {
          height: height,
          scaleX: scaleX,
          scaleY: scaleY,
          width: width
        }));
        setNodeAttrs(innerRenderable, {
          scaleX: 1,
          scaleY: 1
        });
        result.push(_objectSpread$2(_objectSpread$2({}, baseAttrs), {}, {
          width: width,
          height: height
        }, scaledAttrs));
        return result;
      }

      if (!options.disableFlip(id)) {
        var approximationThreshold = 0.001;
        var previousScaleX = selected.scaleX,
            previousRotation = selected.rotation;
        var isScaleChanged = Math.abs(scaleX - Number(previousScaleX)) > approximationThreshold;
        var isRotationChanged = Math.abs(rotation - Number(previousRotation)) > approximationThreshold;

        if (isScaleChanged && isRotationChanged) {
          var updatedAttrs = manageTransformerHorizontalFlip(node);
          result.push(_objectSpread$2(_objectSpread$2({}, baseAttrs), updatedAttrs));
          return result;
        }
      }

      result.push(_objectSpread$2(_objectSpread$2({}, baseAttrs), {}, {
        scaleX: scaleX,
        scaleY: scaleY
      }));
      return result;
    }, []);
    var toBaseGroupIndex = draggingElements.toBaseGroupIndex,
        addedLayers = draggingElements.addedLayers;
    options.onDragend({
      patches: patches,
      toBaseGroupIndex: toBaseGroupIndex,
      addedLayers: addedLayers
    });
    draggingElements.dragEnd();
  });
};

var extractNodeGeometry = function extractNodeGeometry(node) {
  var _getNodeAttrs = getNodeAttrs(node),
      x = _getNodeAttrs.x,
      y = _getNodeAttrs.y,
      width = _getNodeAttrs.width,
      height = _getNodeAttrs.height,
      _getNodeAttrs$rotatio = _getNodeAttrs.rotation,
      rotation = _getNodeAttrs$rotatio === void 0 ? 0 : _getNodeAttrs$rotatio;

  return {
    x: x,
    y: y,
    width: width,
    height: height,
    rotation: rotation
  };
};

var setupGuideLineEvents = function setupGuideLineEvents(transformer, _ref) {
  var _ref$options$offset = _ref.options.offset,
      offset = _ref$options$offset === void 0 ? 0 : _ref$options$offset,
      onMoveEnd = _ref.onMoveEnd,
      onMoveStart = _ref.onMoveStart,
      onElementMove = _ref.onElementMove,
      calculatePoints = _ref.calculatePoints;
  ['dragstart', 'transformstart'].forEach(function (type) {
    return attachEvent(transformer, type, function () {
      onMoveStart();
    });
  });
  ['dragend', 'transformend'].forEach(function (type) {
    return attachEvent(transformer, type, function () {
      onMoveEnd();
    });
  });
  ['dragmove', 'transform'].forEach(function (type) {
    return attachEvent(transformer, type, function (ev) {
      var applySnap = type !== 'transform';

      var _calculatePoints = calculatePoints(extractNodeGeometry(ev.currentTarget)),
          points = _calculatePoints.points,
          _calculatePoints$init = _calculatePoints.initialCoords,
          x = _calculatePoints$init.x,
          y = _calculatePoints$init.y;

      var point = onElementMove(points, {
        x: x,
        y: y
      }, applySnap ? offset : 1) || {};

      if (applySnap && (point.x || point.y)) {
        var diffX = point.x ? x - point.x : 0;
        var diffY = point.y ? y - point.y : 0;
        getNodes(transformer).forEach(function (node) {
          return setNodeAttrs(node, {
            absolutePosition: {
              x: node.getAbsolutePosition().x - diffX,
              y: node.getAbsolutePosition().y - diffY
            }
          });
        });
        transformer.forceUpdate();
      }
    });
  });
};

var setupTransformer = function setupTransformer(layerProvider, configs) {
  var transformer = createTransformer(configs);
  return {
    getNode: function getNode() {
      return transformer;
    },
    getTransformerGeometry: function getTransformerGeometry() {
      var _getNodeAttrs = getNodeAttrs(transformer),
          x = _getNodeAttrs.x,
          y = _getNodeAttrs.y,
          width = _getNodeAttrs.width,
          height = _getNodeAttrs.height,
          rotation = _getNodeAttrs.rotation;

      return {
        x: x,
        y: y,
        width: width,
        height: height,
        rotation: rotation
      };
    },
    setupTransformerInteractions: function setupTransformerInteractions$1(handlers) {
      setupTransformerInteractions(layerProvider, transformer, handlers);
    },
    setupGuideLinesWithTransformer: function setupGuideLinesWithTransformer(handlers) {
      setupGuideLineEvents(transformer, handlers);
    },
    setSelection: function setSelection(ids) {
      var shouldDrawWholeArea = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var nodes = ids.map(function (id) {
        return layerProvider.layerRegistry[id].layer.renderable;
      });
      setNodes(transformer, nodes); // Handle transformer draggable state

      var transformerDraggable = ids.every(function (id) {
        return layerProvider.layerRegistry[id].layer.draggable;
      });
      setNodeAttrs(findTransformerBackShape(transformer), {
        draggable: transformerDraggable
      });
      nodes.forEach(function (node) {
        var _getNodeAttrs2 = getNodeAttrs(node),
            id = _getNodeAttrs2.id;

        var draggable = layerProvider.layerRegistry[id].layer.draggable;
        setNodeAttrs(node, {
          draggable: transformerDraggable ? draggable : false
        });
      });
      transformer.shouldOverdrawWholeArea(transformerDraggable ? shouldDrawWholeArea : false);

      updateTransformer(transformer);
    },
    updateAnchorType: function updateAnchorType(anchorType) {
      var appliedAnchors = getNodeAttrs(transformer).enabledAnchors;
      var pendingAnchors = anchorTypes[anchorType];
      if (!isEqual_1(appliedAnchors, pendingAnchors)) setNodeAttrs(transformer, {
        enabledAnchors: anchorTypes[anchorType],
        rotateEnabled: anchorType !== 'noAnchors'
      });
    },
    setShowTransformer: function setShowTransformer(show) {
      show ? showNode(transformer) : hideNode(transformer);

      updateTransformer(transformer);
    },
    updateStyles: function updateStyles(_ref) {
      var tooltipTextColor = _ref.tooltipTextColor,
          tooltipBackgroundColor = _ref.tooltipBackgroundColor,
          anchorFill = _ref.anchorFill,
          rotaterFill = _ref.rotaterFill,
          rotaterStroke = _ref.rotaterStroke,
          rotaterIconFill = _ref.rotaterIconFill,
          borderStroke = _ref.borderStroke,
          anchorStroke = _ref.anchorStroke;
      setNodeAttrs(transformer, {
        anchorFill: anchorFill,
        borderStroke: borderStroke,
        anchorStroke: anchorStroke
      });
      var rotater = findRect(transformer, '.rotater');
      setNodeAttrs(rotater, {
        stroke: rotaterStroke,
        fill: rotaterFill
      });
      var rotaterIcon = findRect(transformer, '#rotater-icon');
      setNodeAttrs(rotaterIcon, {
        fill: rotaterIconFill
      });
      var labelTag = findNodeFirstIdentifier(transformer, '#label-tag');
      setNodeAttrs(labelTag, {
        fill: tooltipBackgroundColor
      });
      var labelText = findNodeFirstIdentifier(transformer, '#label-text');
      setNodeAttrs(labelText, {
        fill: tooltipTextColor
      });
      transformer === null || transformer === void 0 ? void 0 : transformer.update();
    },
    updateTransformer: function updateTransformer$1() {
      updateTransformer(transformer);
    },
    getActiveAnchor: function getActiveAnchor() {
      return getNodeActiveAnchor(transformer);
    }
  };
};

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function isConstructor(fn) {
  try {
    /* eslint-disable */
    new fn();
    /* eslint-disable */
  } catch (error) {
    return false;
  }

  return true;
}

if ((typeof window.Event !== 'function' || !isConstructor(window.Event)) && !isTest) {
  window.Event = function () {
    function Event(type, options) {
      this.bubbles = !!options && !!options.bubbles;
      this.cancelable = !!options && !!options.cancelable;
      this.composed = !!options && !!options.composed;
      this.type = type;
    }

    return Event;
  }();
}

var userAgentVersion = window.navigator.userAgent.split('Version')[1] || '';
var isSafariesBrokenVersion = userAgentVersion.includes('13.1') && userAgentVersion.includes('Safari');

if (isSafariesBrokenVersion || typeof window.EventTarget !== 'function' || !isConstructor(window.EventTarget)) {
  window.EventTarget = function () {
    function EventTarget() {
      this.__listeners = new Map();
    }

    EventTarget.prototype = Object.create(Object.prototype);

    EventTarget.prototype.addEventListener = function (type, listener, options) {
      if (arguments.length < 2) {
        throw new TypeError("TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ".concat(arguments.length, " present."));
      }

      var __listeners = this.__listeners;
      var actualType = type.toString();

      if (!__listeners.has(actualType)) {
        __listeners.set(actualType, new Map());
      }

      var listenersForType = __listeners.get(actualType);

      if (!listenersForType.has(listener)) {
        // Any given listener is only registered once
        listenersForType.set(listener, options);
      }
    };

    EventTarget.prototype.removeEventListener = function (type, listener) {
      if (arguments.length < 2) {
        throw new TypeError("TypeError: Failed to execute 'addEventListener' on 'EventTarget': 2 arguments required, but only ".concat(arguments.length, " present."));
      }

      var __listeners = this.__listeners;
      var actualType = type.toString();

      if (__listeners.has(actualType)) {
        var listenersForType = __listeners.get(actualType);

        if (listenersForType.has(listener)) {
          listenersForType.delete(listener);
        }
      }
    };

    EventTarget.prototype.dispatchEvent = function (event) {
      if (!(event instanceof Event || event instanceof CustomEvent)) {
        throw new TypeError('Failed to execute \'dispatchEvent\' on \'EventTarget\': parameter 1 is not of type \'Event\'.');
      }

      var type = event.type;
      var __listeners = this.__listeners;

      var listenersForType = __listeners.get(type);

      if (listenersForType) {
        var _iterator = _createForOfIteratorHelper(listenersForType.entries()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                listener = _step$value[0],
                options = _step$value[1];

            try {
              if (typeof listener === 'function') {
                // Listener functions must be executed with the EventTarget as the `this` context.
                listener.call(this, event);
              } else if (listener && typeof listener.handleEvent === 'function') {
                // Listener objects have their handleEvent method called, if they have one
                listener.handleEvent(event);
              }
            } catch (err) {
              // We need to report the error to the global error handling event,
              // but we do not want to break the loop that is executing the events.
              // Unfortunately, this is the best we can do, which isn't great, because the
              // native EventTarget will actually do this synchronously before moving to the next
              // event in the loop.
              setTimeout(function () {
                throw err;
              });
            }

            if (options && options.once) {
              // If this was registered with { once: true }, we need
              // to remove it now.
              listenersForType.delete(listener);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } // Since there are no cancellable events on a base EventTarget,
      // this should always return true.


      return true;
    };

    return EventTarget;
  }();
}

/* eslint-disable */

function mutateKonvaPrototype() {
  var stageMouseUpCopy = Konva.Stage.prototype._mouseup;

  Konva.Stage.prototype._mouseup = function () {
    if (arguments[0].which === 3) return;
    stageMouseUpCopy.apply(this, arguments);
  };

  (function () {
    var func = Konva.Group.prototype.getClientRect;
    var orig = {
      enumerable: false,
      configurable: false,
      writable: false,
      value: func
    };
    var altr = {
      enumerable: false,
      configurable: false,
      writable: false,
      value: function value(config) {
        var _this$children;

        //code from konva
        config = config || {};
        var skipTransform = config.skipTransform;
        var relativeTo = config.relativeTo;
        var minX, minY, maxX, maxY;
        var selfRect = {
          x: Infinity,
          y: Infinity,
          width: 0,
          height: 0
        };
        var that = this;
        (_this$children = this.children) === null || _this$children === void 0 ? void 0 : _this$children.forEach(function (child) {
          // skip invisible children
          if (!child.visible()) {
            return;
          }

          var rect = child.getClientRect({
            relativeTo: that,
            skipShadow: config.skipShadow,
            skipStroke: config.skipStroke
          }); // skip invisible children (like empty groups)

          if (rect.width === 0 && rect.height === 0) {
            return;
          }

          if (minX === undefined) {
            // initial value for first child
            minX = rect.x;
            minY = rect.y;
            maxX = rect.x + rect.width;
            maxY = rect.y + rect.height;
          } else {
            minX = Math.min(minX, rect.x);
            minY = Math.min(minY, rect.y);
            maxX = Math.max(maxX, rect.x + rect.width);
            maxY = Math.max(maxY, rect.y + rect.height);
          }
        }); // if child is group we need to make sure it has visible shapes inside

        var shapes = this.find('Shape');
        var hasVisible = false;

        for (var i = 0; i < shapes.length; i++) {
          var shape = shapes[i];

          if (shape._isVisible(this)) {
            hasVisible = true;
            break;
          }
        }

        if (hasVisible && minX !== undefined) {
          selfRect = {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
          };
        } else {
          selfRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
          };
        } ///added functionality


        var attr = this.attrs;

        if (attr.hasOwnProperty('clipWidth')) {
          selfRect.width = attr.clipWidth;
        }

        if (attr.hasOwnProperty('clipX')) {
          selfRect.x = attr.clipX;
        }

        if (attr.hasOwnProperty('clipY')) {
          selfRect.y = attr.clipY;
        }

        if (attr.hasOwnProperty('clipHeight')) {
          selfRect.height = attr.clipHeight;
        } /// end of added functionality
        //code from konva


        if (!skipTransform) {
          return this._transformedRect(selfRect, relativeTo);
        }

        return selfRect;
      }
    };
    Object.defineProperty(Konva.Group.prototype, 'getOrigClientRect', orig);
    Object.defineProperty(Konva.Group.prototype, 'getClientRect', altr);
  })();
}

mutateKonvaPrototype();
window.Konva.autoDrawEnabled = false;

if (process.env.NODE_ENV !== 'testing' && !isDev) {
  window.Konva = 'never touch this';
}

var requestIdleCallbackPolyfill = function requestIdleCallbackPolyfill(cb, options) {
  return setTimeout(function () {
    return cb();
  }, (options === null || options === void 0 ? void 0 : options.timeout) || 1);
};

var cancelIdleCallbackPolyFill = function cancelIdleCallbackPolyFill(id) {
  return clearTimeout(id);
};

window.requestIdleCallback = window.requestIdleCallback || requestIdleCallbackPolyfill;
window.cancelIdleCallback = window.cancelIdleCallback || cancelIdleCallbackPolyFill;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultConfig = {
  stroke: tinycolor('#ffffff').toRgbString(),
  strokeWidth: 50,
  lineCap: 'round',
  lineJoin: 'round',
  globalCompositeOperation: 'destination-out',
  opacity: 1
};

var onDraw = function onDraw(konvaProvider, layerProvider, options, calculatePointerPosition, handler) {
  var stage = konvaProvider.stage;
  var baseGroupId = options.baseGroupId;
  var mousedown = attachEvent(stage, 'mousedown', function (_ref) {
    var _ref$evt = _ref.evt,
        mouseDownX = _ref$evt.offsetX,
        mouseDownY = _ref$evt.offsetY;

    var lineOptions = _objectSpread$1(_objectSpread$1({}, defaultConfig), options);

    var zIndex = lineOptions.zIndex;
    var baseGroup = layerProvider.layerRegistry[baseGroupId].layer.renderable;

    if (!isInstanceofGroup(baseGroup)) {
      return;
    }

    var _calculatePointerPosi = calculatePointerPosition(mouseDownX, mouseDownY),
        pointDownX = _calculatePointerPosi.x,
        pointDownY = _calculatePointerPosi.y;

    var line = createLine(_objectSpread$1({
      points: [pointDownX, pointDownY, pointDownX, pointDownY]
    }, lineOptions));
    addToNode(baseGroup, line);

    if (zIndex) {
      setNodeAttrs(line, {
        zIndex: zIndex
      });
    } else {
      nodeMoveToTop(line);
    }

    drawNode(stage);
    var detachMousemove = attachEvent(stage, 'mousemove', function (_ref2) {
      var _ref2$evt = _ref2.evt,
          mouseMoveX = _ref2$evt.offsetX,
          mouseMoveY = _ref2$evt.offsetY;

      var _calculatePointerPosi2 = calculatePointerPosition(mouseMoveX, mouseMoveY),
          pointMoveX = _calculatePointerPosi2.x,
          pointMoveY = _calculatePointerPosi2.y;

      var _getNodeAttrs = getNodeAttrs(line),
          oldPoints = _getNodeAttrs.points;

      var newPoints = oldPoints.concat([pointMoveX, pointMoveY]);
      setNodeAttrs(line, {
        points: newPoints
      });
      batchDrawNode(stage);
    });
    attachEventOnce(stage, 'mouseup', function () {
      detachMousemove();

      var _getNodeAttrs2 = getNodeAttrs(line),
          points = _getNodeAttrs2.points;

      handler(_toConsumableArray(points));
      destroyNode(line);
    });
  });
  return function () {
    mousedown();
  };
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function setupCollageImageInteractions(layerProvider, id, handler) {
  var layerObject = layerProvider.layerRegistry[id];
  var _layerObject$layer = layerObject.layer,
      renderable = _layerObject$layer.renderable,
      innerRenderable = _layerObject$layer.innerRenderable;

  function handleEvent() {
    var imageMetrics = getNodeGeometryMetrics(innerRenderable);
    var updatedAttributes = handler(_objectSpread(_objectSpread({}, getNodeGeometryMetrics(renderable)), {}, {
      width: imageMetrics.width,
      height: imageMetrics.height
    }));
    updatedAttributes && setNodeAttrs(renderable, updatedAttributes);
  }

  var detachDragMove = attachEvent(renderable, 'dragmove', handleEvent);
  var detachTransform = attachEvent(renderable, 'transform', handleEvent);
  return function () {
    detachDragMove();
    detachTransform();
  };
}

var setupLayering = function setupLayering(provName) {
  var provider = new KonvaProvider();
  var layerProvider = new LayerProvider();

  if (isDev) {
    var providerName = provName !== null && provName !== void 0 ? provName : 'Provider'; // @ts-ignore

    window["layer".concat(providerName)] = layerProvider; // @ts-ignore

    window["konva".concat(providerName)] = provider;
  }

  return {
    init: function init(configs) {
      return provider.setupStage(configs);
    },
    destroyStage: function destroyStage(containerId) {
      return provider.destroyStage({
        containerId: containerId
      });
    },
    setupAnimationApi: function setupAnimationApi() {
      return new AnimationsApi(layerProvider, new KonvaRenderer(provider, layerProvider));
    },
    setupRenderer: function setupRenderer() {
      return new Renderer(new KonvaRenderer(provider, layerProvider), layerProvider);
    },
    setupTransformer: function setupTransformer$1(configs) {
      return setupTransformer(layerProvider, configs);
    },
    setupCollageImageInteractions: setupCollageImageInteractions.bind({}, layerProvider),
    getInteractions: function getInteractions() {
      return {
        onClick: onClick.bind({}, layerProvider),
        onHover: onHover.bind({}, layerProvider),
        onStageClick: onStageClick.bind({}, provider),
        onMousedown: onMousedown.bind({}, layerProvider),
        onDoubleClick: onDoubleClick.bind({}, layerProvider),
        onContextMenu: onContextMenu.bind({}, layerProvider),
        onStageMousedown: onStageMousedown.bind({}, provider),
        onStageMouseMove: function onStageMouseMove$1(handler) {
          return onStageMouseMove(provider, layerProvider, handler);
        },
        onDraw: onDraw.bind({}, provider, layerProvider)
      };
    },
    getUtils: function getUtils() {
      return {
        pointerLeave: function pointerLeave() {
          var _provider$stage;

          return (_provider$stage = provider.stage) === null || _provider$stage === void 0 ? void 0 : _provider$stage._pointerleave(new PointerEvent('pointerleave'));
        },
        createLayers: function createLayers$1(layers, inToId) {
          var acc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          return createLayers(layerProvider, layers, inToId, acc);
        },
        layerToImage: layerToImage.bind({}, layerProvider),
        onLayerReady: function onLayerReady$1(layerId, callback, options) {
          return onLayerReady(layerProvider, layerId, callback, options);
        },
        layerToCanvas: layerToCanvas.bind({}, layerProvider),
        onLayerUpdate: function onLayerUpdate$1(layerId, callback) {
          var excludeKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          var options = arguments.length > 3 ? arguments[3] : undefined;
          return onLayerUpdate(layerProvider, layerId, callback, excludeKeys, options);
        },
        onLayerReadyWithChildren: function onLayerReadyWithChildren$1(layerId, callback, options) {
          return onLayerReadyWithChildren(layerProvider, layerId, callback, options);
        },
        onLayerChange: function onLayerChange$1(layerId, callback) {
          var excludeKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          var options = arguments.length > 3 ? arguments[3] : undefined;
          return onLayerChange(layerProvider, layerId, callback, excludeKeys, options);
        },
        layerToDataUrl: layerToDataUrl.bind({}, layerProvider),
        isLayerReady: isLayerReady.bind({}, layerProvider),
        getImageLayerResources: getImageLayerResources.bind({}, layerProvider, provider),
        getTextTopLeftPosition: getTextTopLeftPosition.bind({}, layerProvider),
        stageZoomReposition: stageZoomReposition.bind({}, provider),
        stageScaleChange: stageScaleChange.bind({}, provider),
        stageReposition: stageReposition.bind({}, provider),
        getStagePosition: getStagePosition.bind({}, provider),
        resetStagePosition: resetStagePosition.bind({}, provider),
        getTransformedText: getTransformedText
      };
    }
  };
};

export { setupLayering as default };
